import store from '../redux/store';
import { openCart, addItem } from '../redux/cart/actions';

export default () => {
  const el = document.querySelector('[data-bcsf-overrides]');

  if (el) {
    const selectors = {
      addToCart: '[data-bcsf-override-add-to-cart]',
    };

    el.addEventListener('click', (e) => {
      let targetElement = e.target;

      // event bubbling handle click on option/label
      while (targetElement !== e.currentTarget) {
        // if the clicked object is the the add to cart button
        if (targetElement.matches(selectors.addToCart)) {
          const data = JSON.parse(targetElement.dataset.jsonProps);
          const { measurements } = data;
          const variantId = document.getElementById(data.variantInputId).value;
          const variant = data.items.find((node) => node.variantId === variantId);

          e.preventDefault();

          store.dispatch(openCart());
          store.dispatch(addItem(variantId, 1, variant, null, measurements));
        }
        targetElement = targetElement.parentElement;
      }
    });
  }
};
